export default __webpack_public_path__ + "static/media/Mask.b7662466.png";